import React from 'react';
import CommentIcon from '@material-ui/icons/Comment';

const UnseenCommentsIndicator = (props) => {
    return <CommentIcon color="action" fontSize="small"/>
}

export default UnseenCommentsIndicator;


// WEBPACK FOOTER //
// ./src/components/ProjectListItem/UnseenCommentsChit.js